import {dayNamesEnLowerCase} from '@/library/date';
import {DEFAULT_HOUR_HEIGHT_PIXELS} from '@/library/modules/calendar/calendar';
import personalDashboard from '@/store/modules/personalDashboard';
import {createStore, Store} from 'vuex';
import actions from './actions';
import getters from './getters';
import clipboard from './modules/clipboard';
import form from './modules/form';
import lightBox from './modules/lightBox';
import moduleStates from './modules/module';
import notification from './modules/notification';
import telephoneToolbar from './modules/telephoneToolbar';
import timeTracker from './modules/timeTracker';
import mutations from './mutations';

export function defaultCurrentUser(): CurrentUser
{
    return {
        name: '',
        admin: false,
        isMultiLogin: false,
        isImpersonate: false,
        isSupport: false,
        telephoneToolbar: false,
        id: 0,
        employeeId: 0,
        isCEO: false,
        hasTimeTracker: false,
        appointmentCalendarId: 0,
        hasChat: false,
        modules: {},
        chatToken: ''
    };
}

const state: RootState = {
    layoutData: {
        title: '',
        user: defaultCurrentUser(),
        users: {},
        resources: {},
        modules: [],
        colors: {},
        hasLogo: false,
        freeIntranet: false,
        hasClient: false,
        storageBlocked: false,
        contactMail: true,
        moduleListDirect: true,
        menuFast: false,
        personalDashboardPopup: false,
        defaultAddress: null,
        phone_settings: {},
        assistant: {},
        employee_configuration: {
            version: 0,
            enrolment_version: 0,
            sub_module: [],
            allowed_resources: [],
            time_tracker_mode: 0,
            time_tracker_mode_employee: 0,
            time_tracker_mode_employee_system: 0,
            time_tracker_app_only: false,
            employee_apis: [],
        },
        employee_up_to_date: {
            prompt: false,
            closeable: true,
            date: null,
        },
        time_tracker_data: {
            work_days: dayNamesEnLowerCase.reduce((carry, day) => Object.assign(carry, {[day]: null}), {}),
            calculate_non_workdays: false,
            calculate_before_work_start: false,
            calculate_after_work_end: false,
            allow_work_outside_work_time: false,
        },
        employee_apis_enabled: [],
        hasApp: false,
        hasTerminalApp: false,
        useTerminalApp: false,
        loaded: 0,
        websocket_url: '',
        rightsBy: [],
        employee_first_day: false,
        sentryActive: false,
    },
    bookmark: {
        id: 0,
        list: [],
    },
    loader: {
        active: false,
        text: '',
    },
    hideApp: false,
    headline: '',
    topMessages: [],
    flashMessages: [],
    layoutDataLoaded: false,
    pageLoading: false,
    loggedIn: false,
    portunaBoxOpened: {},
    tabBar: {},
    foldContainer: {},
    tileMenu: null,
    moduleMenus: {},
    moduleMenu: [],
    _debugHistory: [],
    _debug: null,
    errors: [],
    error: null,
    users: {},
    roles: {},
    employees: {},
    entities: {},
    tooltips: {
        user: {},
        employee: {},
        task: {},
    },
    showToolbar: true,
    popups: {},
    calendarHourHeight: DEFAULT_HOUR_HEIGHT_PIXELS,
    viewSize: {
        xs: false,
        xsDown: false,
        xsUp: false,
        sm: false,
        smDown: false,
        smUp: false,
        md: false,
        mdDown: false,
        mdUp: false,
        lg: false,
        lgDown: false,
        lgUp: false,
        xl: false,
        xlDown: false,
        xlUp: false,
        xxl: false,
        xxlDown: false,
        xxlUp: false,
    }
};

let store: Store<RootState> = createStore({
    strict: process.env.NODE_ENV !== 'production',
    state() {
        return state;
    },
    actions,
    getters,
    mutations,
    modules: {
        clipboard,
        form,
        lightBox,
        module: moduleStates,
        notification,
        telephoneToolbar,
        timeTracker,
        personalDashboard,
    },
});

/*if(module.hot)
{
    module.hot.accept([
        './actions',
        //'./getters',
        './mutations',
        './modules/home',
        './modules/news',
        './modules/notification',
        './modules/timeTracker',
        './modules/telephoneToolbar',
    ], () =>
    {
        store.hotUpdate({
            actions: require('./actions'),
            //getters: require('./getters'),
            mutations: require('./mutations'),
            modules: {
                home: require('./modules/home').default,
                news: require('./modules/news').default,
                timeTracker: require('./modules/timeTracker').default,
                notification: require('./modules/notification').default,
                telephoneToolbar: require('./modules/telephoneToolbar').default,
            }
        });
    });
}*/

export default store;